"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UILayer = _interopRequireDefault(require("../layer/UILayer"));

var _focusStylesListener = require("../listeners/focusStylesListener");

// Based on https://github.com/twbs/bootstrap/blob/v3.3.6/dist/js/bootstrap.js
function measureScrollbar() {
  var scrollDiv = document.createElement('div');
  scrollDiv.className = 'uiFullScreen-scrollbar-measure';
  document.body.appendChild(scrollDiv);
  var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarWidth;
}

var UIFullScreen = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UIFullScreen, _Component);

  function UIFullScreen(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UIFullScreen);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UIFullScreen).call(this, props));

    _this.handleCloseComplete = function () {
      if (_this._lastFocus) {
        if ((0, _focusStylesListener.isPageInKeyboardMode)()) {
          _this._lastFocus.focus();
        }

        _this._lastFocus = null;
      }

      if (_this.constructor.layerCount === 0) {
        _this.restoreBackgroundScrolling();
      }
    };

    _this._lastFocus = document.activeElement;
    return _this;
  }

  (0, _createClass2.default)(UIFullScreen, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.constructor.layerCount += 1;

      if (this.constructor.layerCount === 1) {
        this.disableBackgroundScrolling();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.constructor.layerCount -= 1;
    }
  }, {
    key: "disableBackgroundScrolling",
    value: function disableBackgroundScrolling() {
      var _this2 = this;

      this.addFauxScrollbar();
      [document.documentElement, document.body].forEach(function (el) {
        return el.classList && el.classList.add(_this2.constructor.NO_SCROLL_CLASS);
      });
    }
  }, {
    key: "restoreBackgroundScrolling",
    value: function restoreBackgroundScrolling() {
      var _this3 = this;

      this.removeFauxScrollbar();
      [document.documentElement, document.body].forEach(function (el) {
        return el.classList && el.classList.remove(_this3.constructor.NO_SCROLL_CLASS);
      });
    }
  }, {
    key: "addFauxScrollbar",
    value: function addFauxScrollbar() {
      var bodyHasScrollbar = document.body.clientWidth < window.innerWidth;

      if (bodyHasScrollbar) {
        var scrollbarWidth = measureScrollbar() + "px"; // To avoid changing the body width when we disable scrollbar, we replace
        // the scrollbar with padding of equal width.

        this.constructor.originalBodyPaddingRight = document.body.style.paddingRight;
        document.body.style.paddingRight = scrollbarWidth;
      }
    }
  }, {
    key: "removeFauxScrollbar",
    value: function removeFauxScrollbar() {
      document.body.style.paddingRight = this.constructor.originalBodyPaddingRight;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["children"]);
      return _react.default.createElement(_UILayer.default, (0, _extends2.default)({}, rest, {
        onCloseComplete: this.handleCloseComplete
      }), _react.default.cloneElement(_react.default.Children.only(children), {
        open: true
      }));
    }
  }]);
  return UIFullScreen;
}(_react.Component);

exports.default = UIFullScreen;
UIFullScreen.layerCount = 0;
UIFullScreen.NO_SCROLL_CLASS = 'uiFullScreenBackground';
UIFullScreen.originalBodyPaddingRight = '';
UIFullScreen.propTypes = {
  children: _propTypes.default.element.isRequired,
  rootNode: _propTypes.default.object,
  Transition: _propTypes.default.elementType
};
UIFullScreen.displayName = 'UIFullScreen';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/dialog/UIFullScreen.js
// module id = 793
// module chunks = 209 210 211 212